import type { KeyboardEvent } from 'react'

/*
  Several Webflow controls are styled <div>/<a> elements rather than <button>.
  To keep the design pixel-perfect we keep those tags but make them keyboard
  operable: this returns an onKeyDown that fires the handler on Enter / Space.
*/
export function activateOnKey(handler: () => void) {
    return (event: KeyboardEvent<HTMLElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            handler()
        }
    }
}
